import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemEventsDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-system-events-delete',
	path: '/secure/admin/DeleteEventType.jspa',
};
